const HealthSystem = () => {
    return(
        <>
        <div className="healthBlock">
        <div className="healthInfo">
            <p className="healthInfoP">The NEED</p>
            <h2 className="healthInfoH2">The health system isn't equitable for diverse patients.</h2>
            <p className="healthInfoP2">Medical racism. Severe distrust in medical providers. Misdiagnoses. 
               Lack of access to coverage. These are just a few barriers culturally diverse patients face.
               We believe every human deserves equitable health care. That's why we built Violet.</p>
        </div>
        <div className="healthImg">
            <img src=".\img\women.png" alt="" />
        </div>
        </div>
        </>
    );
}

export default HealthSystem;